// TODO IMPROVEMENT: Modify backend response for camelCase

import { TagType as TagTypeEnum } from '../../content-management/shared/enums/tag-type';

export interface ITag {
  id: string;
  tagType: TagTypeEnum;
  text: string;
  automaticallyApplied: boolean;
}

export interface ITagCMSApi {
  id: string;
  tagType: TagTypeEnum;
  text: string;
}

export class Tag implements ITag {
  constructor(
    public id: string = '',
    public tagType: TagTypeEnum,
    public text: string = '',
    public automaticallyApplied: boolean = false,
  ) {}
}
